<template>
	<v-dialog
		:value="dialog"
		width="unset"
		:persistent="true"
		:overlay-color="overlayColor"
		:overlay-opacity="overlayOpacity"
		@click:outside="!persistent ? handleClose() : ''"
		:fullscreen="fullscreen"
		:content-class="modalContentClass"
		:transition="transition"
	>
		<slot></slot>
	</v-dialog>
</template>

<script>
	export default {
		name: 'BasicModal',
		components: {},

		props: {
			dialog: { type: Boolean, default: false },
			fullscreen: { type: Boolean, default: false },
			persistent: { type: Boolean, default: true },
			overlayColor: { type: String, default: 'modal_overlay' },
			overlayOpacity: { type: String, default: '0.8' },
			closeOnEscape: { type: Boolean, default: true },
			contentClass: { type: String, default: '' },
			transition: { type: String, default: 'dialog-transition' },
		},

		data() {
			return {
				alert: {},
			};
		},

		mounted() {
			if (this.closeOnEscape) {
				document.addEventListener('keydown', this.handleKeyDown);
			}
		},

		beforeDestroy() {
			if (this.closeOnEscape) {
				document.removeEventListener('keydown', this.handleKeyDown);
			}
		},

		methods: {
			handleClose: function() {
				this.$emit('close');
			},

			handleKeyDown: function(e) {
				if (e.key === 'Escape') {
					this.handleClose();
				}
			},

			setAlert: function(alert) {
				this.alert = alert;
			},
		},

		watch: {
			dialog(newVal) {
				if (this.closeOnEscape) {
					if (newVal) {
						document.addEventListener('keydown', this.handleKeyDown);
					} else {
						document.removeEventListener('keydown', this.handleKeyDown);
					}
				}
			},
		},

		computed: {
			modalContentClass() {
				return ['basic-modal', this.contentClass].filter(Boolean).join(' ');
			},
		},
	};
</script>

<style lang="scss">
	.v-dialog.basic-modal {
		background-color: var(--v-white-base);
	}

	.v-dialog.basic-modal.task-right-modal {
		width: min(480px, 100vw) !important;
		max-width: 100vw;
		height: 100%;
		max-height: 100%;
		margin: 0 0 0 auto;
		overflow: hidden;
		border-left: 1px solid var(--portal-border);
		border-radius: 0;
		background: var(--portal-surface);
		box-shadow: -14px 0 46px rgba(16, 17, 15, 0.16);
	}

	.v-dialog.basic-modal.document-lightbox {
		width: min(1120px, calc(100vw - 48px)) !important;
		max-width: none;
		height: calc(100vh - 48px);
		max-height: calc(100vh - 48px);
		margin: 24px auto;
		overflow: hidden;
		border: 1px solid color-mix(in srgb, var(--portal-border) 85%, transparent);
		border-radius: var(--brand-surface-radius, 22px);
		background: var(--portal-surface);
		box-shadow: 0 28px 80px rgba(16, 17, 15, 0.24);
	}

	@media (max-width: 599px) {
		.v-dialog.basic-modal.task-right-modal {
			width: 100vw !important;
			border-left: 0;
		}

		.v-dialog.basic-modal.document-lightbox {
			width: 100vw !important;
			height: 100vh;
			max-height: 100vh;
			margin: 0;
			border: 0;
			border-radius: 0;
		}
	}
</style>
